<template>
  <div id="app">

    <!-- 這裏是會被緩存的視圖組件-->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>

    <!-- 這裏是不被緩存的視圖組件-->
    <router-view v-if="!$route.meta.keepAlive">

    </router-view>

  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>

  body {
    margin: 0;
    padding: 0;
  }

  @font-face {
    font-family: "楷體";
  }

  #app {
    font-family: "楷體";
    text-align: center;
    overflow: hidden;
    height: auto;
  }

  /*手機*/
  @media screen and (max-width: 600px) {

    .container {
      width: 100%;
      height: 100%;
      margin: 0 auto;
      background-color: white;
      padding: 0;
    }

    .top-nav-container {
      width: 100%;
      height: 50px;
      background-color: #f2c510;
      text-align: center;
      position: fixed;
      top: 0;
      z-index: 100;
    }

    .top-nav-container span {
      line-height: 50px;
      color: black;
      font-size: 16px;
      font-weight: 600;
    }

    .top-nav-container span {
      line-height: 50px;
      font-size: 16px;
      font-weight: bold;
    }

  }

  /*平板*/
  @media screen and (min-width: 600px) and (max-width: 960px) {

    .container {
      max-width: 480px;
      margin: 0 auto;
      min-height: calc(100vh);
      padding: 0;
    }

    .top-nav-container {
      width: 480px;
      height: 50px;
      background-color: #f2c510;
      text-align: center;
      position: fixed;
      top: 0;
      z-index: 100;
    }

    .top-nav-container span {
      line-height: 50px;
      font-size: 16px;
      font-weight: bold;
    }
  }

  /*PC*/
  @media screen and (min-width: 960px) {

    .container {
      max-width: 480px;
      margin: 0 auto;
      min-height: calc(100vh);
      padding: 0;
    }

    .top-nav-container {
      width: 480px;
      height: 50px;
      background-color: #f2c510;
      text-align: center;
      position: fixed;
      top: 0;
      z-index: 100;
      max-width: 480px;
      margin: 0 auto;
    }

    .top-nav-container span {
      line-height: 50px;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
    }

  }

  .aline {
    width: 100%;
    height: 1px;
    background-color: #EFEFEF;
  }

  .book-display-container {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 33%;
    text-align: center;
    margin-top: 20px;
    cursor: pointer;
  }

  .book-display-container img {
    width: 80%;
  }

  .book-display-container span {
    display: block;
    color: #999999;
    font-size: 14px;
    line-height: 20px;
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 10%;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue